import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientMetadataComponent } from '@brightnav/ui';
import { BrightnavLayoutService } from '../brightnav-layout.service';

@Component({
  selector: 'bn-brightnav-layout',
  imports: [CommonModule, ClientMetadataComponent],
  templateUrl: './brightnav-layout.component.html',
  styleUrl: './brightnav-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrightnavLayoutComponent {
  layoutService = inject(BrightnavLayoutService);

  collapsed = computed(()=> this.layoutService.collapsed());

  toggleSidebar() {
    this.layoutService.toggleCollapsed();
  }
}
